import { t } from "i18next"
import { z } from "zod"
import { stringRequired } from "@/models/common"
import { Symptom } from "@/modules/patients/detail/therapy-prescription/de/services/__generated__/deTherapyPrescriptionFragment.graphql"

export const therapyPrescriptionAdditionalInformationMaxLength = 200

export const TherapyPrescriptionSchema = z
  .object({
    therapy: stringRequired.max(60, { message: "common.fieldErrorList.characterLimit" }),
    treatmentUnit: stringRequired.refine((value) => Number(value) >= 1 && Number(value) <= 99, {
      message: t("common.fieldErrorList.valueInRange", { min: 1, max: 99 }),
    }),
    frequency: stringRequired.max(40, { message: "common.fieldErrorList.characterLimit" }),
    requestTherapyReport: z.boolean(),
    diagnosisCode: stringRequired,
    symptoms: z.array(z.custom<Symptom>()).optional(),
    otherSymptoms: z.string().max(60, { message: "common.fieldErrorList.characterLimit" }),
    additionalInformation: z
      .string()
      .max(therapyPrescriptionAdditionalInformationMaxLength, { message: "common.fieldErrorList.characterLimit" }),
  })
  .superRefine((data, ctx) => {
    if ((data.symptoms ?? []).length === 0 && (!data.otherSymptoms || data.otherSymptoms.trim().length === 0)) {
      ctx.addIssue({
        code: "custom",
        path: ["symptoms"],
        message: "common.fieldErrorList.requiredField",
      })
    }
  })

export type TherapyPrescription = z.infer<typeof TherapyPrescriptionSchema>
